import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: "/api",
  credentials: "include", // include cookies
});

export const baseQueryWithCsrf = async (args, api, extraOptions) => {
  try {
    const method = (args?.method || "GET").toUpperCase();

    if (["POST", "PUT", "DELETE"].includes(method)) {
      const csrfRes = await fetch("/api/csrf-token", {
        credentials: "include",
      });

      const contentType = csrfRes.headers.get("content-type");
      if (!csrfRes.ok || !contentType?.includes("application/json")) {
        const text = await csrfRes.text();
        console.error("CSRF fetch failed, got HTML:", text);
        throw new Error("CSRF fetch failed");
      }

      const { csrfToken } = await csrfRes.json();

      args.headers = {
        ...(args.headers || {}),
        "X-CSRF-Token": csrfToken,
      };
    }

    return await baseQuery(args, api, extraOptions);
  } catch (err) {
    console.error("baseQueryWithCsrf error:", err);
    return { error: { status: 500, data: err.message } };
  }
};
